<template>
  <div class="register-panel">
    <RegisterStep1
      v-if="curStep === '1'"
      @switchLogin="$emit('switchLogin')"
      @reset-count-down="resetCountDown"
      @start-count-down="startCountDown"
    />
    <RegisterStep2
      v-if="curStep === '2'"
      @reset-count-down="resetCountDown"
      @start-count-down="startCountDown"
    />
  </div>
</template>
<script>
import RegisterStep1 from './RegisterStep1'
import RegisterStep2 from './RegisterStep2'

import store from './simpleStore'

export default {
  name: 'RegisterPanel',
  components: {
    RegisterStep1,
    RegisterStep2
  },
  data() {
    return {
      timer: null,
      state: store.state
    }
  },
  created() {
    this.$track('login_signup')
  },
  computed: {
    curStep() {
      return this.state.curStep
    },
    countDown() {
      return this.state.countDown
    }
  },
  methods: {
    startCountDown() {
      const count = this.countDown
      if (count > 0) {
        this.timer = setTimeout(() => {
          store.setCountDownAction(count - 1)
          this.startCountDown()
        }, 1000)
      }
    },
    resetCountDown() {
      store.setCountDownAction(0)
      clearTimeout(this.timer)
      this.timer = null
    },
    resetRegister() {
      store.setCurStepAction('1')
      store.resetForm()
      this.resetCountDown()
    }
  },
  beforeDestroy() {
    this.resetRegister()
  }
}
</script>
<style lang="less" src="./style.less"></style>
